import type { BaseIconProps } from '@carlsberggroup/malty.atoms.base-icon';
import { AddContent } from '@carlsberggroup/malty.icons.add-content';
import { AddEvent } from '@carlsberggroup/malty.icons.add-event';
import { AddProject } from '@carlsberggroup/malty.icons.add-project';
import { AddedDocument } from '@carlsberggroup/malty.icons.added-document';
import { Alert } from '@carlsberggroup/malty.icons.alert';
import { AlertConnection } from '@carlsberggroup/malty.icons.alert-connection';
import { AppDropbox } from '@carlsberggroup/malty.icons.app-dropbox';
import { AppFacebook } from '@carlsberggroup/malty.icons.app-facebook';
import { AppGithub } from '@carlsberggroup/malty.icons.app-github';
import { AppInstagram } from '@carlsberggroup/malty.icons.app-instagram';
import { AppLinkedin } from '@carlsberggroup/malty.icons.app-linkedin';
import { AppPowerbi } from '@carlsberggroup/malty.icons.app-powerbi';
import { AppSkype } from '@carlsberggroup/malty.icons.app-skype';
import { Arrange } from '@carlsberggroup/malty.icons.arrange';
import { ArrowSmallDown } from '@carlsberggroup/malty.icons.arrow-small-down';
import { ArrowSmallLeft } from '@carlsberggroup/malty.icons.arrow-small-left';
import { ArrowSmallRight } from '@carlsberggroup/malty.icons.arrow-small-right';
import { ArrowSmallUp } from '@carlsberggroup/malty.icons.arrow-small-up';
import { At } from '@carlsberggroup/malty.icons.at';
import { Attachment } from '@carlsberggroup/malty.icons.attachment';
import { Balance } from '@carlsberggroup/malty.icons.balance';
import { Bell } from '@carlsberggroup/malty.icons.bell';
import { BellNotification } from '@carlsberggroup/malty.icons.bell-notification';
import { Bold } from '@carlsberggroup/malty.icons.bold';
import { Book } from '@carlsberggroup/malty.icons.book';
import { Bookmark } from '@carlsberggroup/malty.icons.bookmark';
import { BookmarkFilled } from '@carlsberggroup/malty.icons.bookmark-filled';
import { Bottle } from '@carlsberggroup/malty.icons.bottle';
import { BottleCraft } from '@carlsberggroup/malty.icons.bottle-craft';
import { Calendar } from '@carlsberggroup/malty.icons.calendar';
import { CalendarAutumn } from '@carlsberggroup/malty.icons.calendar-autumn';
import { CalendarConfirm } from '@carlsberggroup/malty.icons.calendar-confirm';
import { CalendarEvents } from '@carlsberggroup/malty.icons.calendar-events';
import { CalendarSpring } from '@carlsberggroup/malty.icons.calendar-spring';
import { CalendarSummer } from '@carlsberggroup/malty.icons.calendar-summer';
import { CalendarWholeYear } from '@carlsberggroup/malty.icons.calendar-whole-year';
import { CalendarWinter } from '@carlsberggroup/malty.icons.calendar-winter';
import { Camera } from '@carlsberggroup/malty.icons.camera';
import { Can } from '@carlsberggroup/malty.icons.can';
import { Card } from '@carlsberggroup/malty.icons.card';
import { CardPlus } from '@carlsberggroup/malty.icons.card-plus';
import { CarlsbergFilled } from '@carlsberggroup/malty.icons.carlsberg-filled';
import { CarlsbergOutlined } from '@carlsberggroup/malty.icons.carlsberg-outlined';
import { CarretDown } from '@carlsberggroup/malty.icons.carret-down';
import { CarretLeft } from '@carlsberggroup/malty.icons.carret-left';
import { CarretMove } from '@carlsberggroup/malty.icons.carret-move';
import { CarretRight } from '@carlsberggroup/malty.icons.carret-right';
import { CarretUp } from '@carlsberggroup/malty.icons.carret-up';
import { Cart } from '@carlsberggroup/malty.icons.cart';
import { CartAdded } from '@carlsberggroup/malty.icons.cart-added';
import { CartLabel } from '@carlsberggroup/malty.icons.cart-label';
import { CartNotification } from '@carlsberggroup/malty.icons.cart-notification';
import { Change } from '@carlsberggroup/malty.icons.change';
import { Check } from '@carlsberggroup/malty.icons.check';
import { CheckboxCheck } from '@carlsberggroup/malty.icons.checkbox-check';
import { CheckboxCheckAlternate } from '@carlsberggroup/malty.icons.checkbox-check-alternate';
import { CheckboxCheckOutline } from '@carlsberggroup/malty.icons.checkbox-check-outline';
import { CheckboxCheckSquare } from '@carlsberggroup/malty.icons.checkbox-check-square';
import { CheckboxEmpty } from '@carlsberggroup/malty.icons.checkbox-empty';
import { ChevronDown } from '@carlsberggroup/malty.icons.chevron-down';
import { ChevronLeft } from '@carlsberggroup/malty.icons.chevron-left';
import { ChevronRight } from '@carlsberggroup/malty.icons.chevron-right';
import { ChevronUp } from '@carlsberggroup/malty.icons.chevron-up';
import { Clock } from '@carlsberggroup/malty.icons.clock';
import { ClockFilled } from '@carlsberggroup/malty.icons.clock-filled';
import { Clone } from '@carlsberggroup/malty.icons.clone';
import { Close } from '@carlsberggroup/malty.icons.close';
import { CoinDollar } from '@carlsberggroup/malty.icons.coin-dollar';
import { CoinEuro } from '@carlsberggroup/malty.icons.coin-euro';
import { Compass } from '@carlsberggroup/malty.icons.compass';
import { CompassFilled } from '@carlsberggroup/malty.icons.compass-filled';
import { Connected } from '@carlsberggroup/malty.icons.connected';
import { Contract } from '@carlsberggroup/malty.icons.contract';
import { Cookies } from '@carlsberggroup/malty.icons.cookies';
import { Coupon } from '@carlsberggroup/malty.icons.coupon';
import { Customer } from '@carlsberggroup/malty.icons.customer';
import { CustomerAdd } from '@carlsberggroup/malty.icons.customer-add';
import { CustomerQuestion } from '@carlsberggroup/malty.icons.customer-question';
import { Customers } from '@carlsberggroup/malty.icons.customers';
import { DataTransfer } from '@carlsberggroup/malty.icons.data-transfer';
import { DiagonalDownLeft } from '@carlsberggroup/malty.icons.diagonal-down-left';
import { DiagonalDownRight } from '@carlsberggroup/malty.icons.diagonal-down-right';
import { DiagonalUpLeft } from '@carlsberggroup/malty.icons.diagonal-up-left';
import { DiagonalUpRight } from '@carlsberggroup/malty.icons.diagonal-up-right';
import { Diploma } from '@carlsberggroup/malty.icons.diploma';
import { Diploma2 } from '@carlsberggroup/malty.icons.diploma2';
import { Download } from '@carlsberggroup/malty.icons.download';
import { Draughtmaster } from '@carlsberggroup/malty.icons.draughtmaster';
import { Edit } from '@carlsberggroup/malty.icons.edit';
import { EllipsisVertical } from '@carlsberggroup/malty.icons.ellipsis-vertical';
import { Email } from '@carlsberggroup/malty.icons.email';
import { Expand } from '@carlsberggroup/malty.icons.expand';
import { ExternalLink } from '@carlsberggroup/malty.icons.external-link';
import { EyeHide } from '@carlsberggroup/malty.icons.eye-hide';
import { EyeShow } from '@carlsberggroup/malty.icons.eye-show';
import { File } from '@carlsberggroup/malty.icons.file';
import { FilesCsv } from '@carlsberggroup/malty.icons.files-csv';
import { FilesJson } from '@carlsberggroup/malty.icons.files-json';
import { FilesPdf } from '@carlsberggroup/malty.icons.files-pdf';
import { FilesXls } from '@carlsberggroup/malty.icons.files-xls';
import { Filters } from '@carlsberggroup/malty.icons.filters';
import { Flash } from '@carlsberggroup/malty.icons.flash';
import { GlassGoblet } from '@carlsberggroup/malty.icons.glass-goblet';
import { GlassMug } from '@carlsberggroup/malty.icons.glass-mug';
import { GlassMugEmpty } from '@carlsberggroup/malty.icons.glass-mug-empty';
import { GlassWeissbier } from '@carlsberggroup/malty.icons.glass-weissbier';
import { Globe } from '@carlsberggroup/malty.icons.globe';
import { Headline } from '@carlsberggroup/malty.icons.headline';
import { Heart } from '@carlsberggroup/malty.icons.heart';
import { HeartFilled } from '@carlsberggroup/malty.icons.heart-filled';
import { Help } from '@carlsberggroup/malty.icons.help';
import { HideMenu } from '@carlsberggroup/malty.icons.hide-menu';
import { History } from '@carlsberggroup/malty.icons.history';
import { Home } from '@carlsberggroup/malty.icons.home';
import { Hop } from '@carlsberggroup/malty.icons.hop';
import { Image } from '@carlsberggroup/malty.icons.image';
import { Information } from '@carlsberggroup/malty.icons.information';
import { Italic } from '@carlsberggroup/malty.icons.italic';
import { ItemAdd } from '@carlsberggroup/malty.icons.item-add';
import { ItemBlock } from '@carlsberggroup/malty.icons.item-block';
import { ItemCheck } from '@carlsberggroup/malty.icons.item-check';
import { ItemCheckDefault } from '@carlsberggroup/malty.icons.item-check-default';
import { ItemCheckFilled } from '@carlsberggroup/malty.icons.item-check-filled';
import { ItemClose } from '@carlsberggroup/malty.icons.item-close';
import { ItemCloseFilled } from '@carlsberggroup/malty.icons.item-close-filled';
import { Library } from '@carlsberggroup/malty.icons.library';
import { Loading } from '@carlsberggroup/malty.icons.loading';
import { LocationIp } from '@carlsberggroup/malty.icons.location-ip';
import { Lock } from '@carlsberggroup/malty.icons.lock';
import { LockOpen } from '@carlsberggroup/malty.icons.lock-open';
import { Map } from '@carlsberggroup/malty.icons.map';
import { Market } from '@carlsberggroup/malty.icons.market';
import { MediaPause } from '@carlsberggroup/malty.icons.media-pause';
import { MediaPlay } from '@carlsberggroup/malty.icons.media-play';
import { MediaSound } from '@carlsberggroup/malty.icons.media-sound';
import { MediaSoundOff } from '@carlsberggroup/malty.icons.media-sound-off';
import { MediaStop } from '@carlsberggroup/malty.icons.media-stop';
import { Menu } from '@carlsberggroup/malty.icons.menu';
import { MenuLeft } from '@carlsberggroup/malty.icons.menu-left';
import { MenuRight } from '@carlsberggroup/malty.icons.menu-right';
import { Minus } from '@carlsberggroup/malty.icons.minus';
import { Mobile } from '@carlsberggroup/malty.icons.mobile';
import { More } from '@carlsberggroup/malty.icons.more';
import { Mouse } from '@carlsberggroup/malty.icons.mouse';
import { Notepad } from '@carlsberggroup/malty.icons.notepad';
import { Outlet } from '@carlsberggroup/malty.icons.outlet';
import { OutletPlus } from '@carlsberggroup/malty.icons.outlet-plus';
import { Pack } from '@carlsberggroup/malty.icons.pack';
import { PackageKeg } from '@carlsberggroup/malty.icons.package-keg';
import { PackageWholesaler } from '@carlsberggroup/malty.icons.package-wholesaler';
import { Paint } from '@carlsberggroup/malty.icons.paint';
import { Pallet } from '@carlsberggroup/malty.icons.pallet';
import { Pencil } from '@carlsberggroup/malty.icons.pencil';
import { PhoneClassic } from '@carlsberggroup/malty.icons.phone-classic';
import { Pilsner } from '@carlsberggroup/malty.icons.pilsner';
import { Pin } from '@carlsberggroup/malty.icons.pin';
import { PinActive } from '@carlsberggroup/malty.icons.pin-active';
import { PinChurn } from '@carlsberggroup/malty.icons.pin-churn';
import { PinClosed } from '@carlsberggroup/malty.icons.pin-closed';
import { PinInactive } from '@carlsberggroup/malty.icons.pin-inactive';
import { PinIndirect } from '@carlsberggroup/malty.icons.pin-indirect';
import { PinLabeling } from '@carlsberggroup/malty.icons.pin-labeling';
import { PinParked } from '@carlsberggroup/malty.icons.pin-parked';
import { PinProspect } from '@carlsberggroup/malty.icons.pin-prospect';
import { PinSeveral } from '@carlsberggroup/malty.icons.pin-several';
import { Pint } from '@carlsberggroup/malty.icons.pint';
import { Plus } from '@carlsberggroup/malty.icons.plus';
import { Power } from '@carlsberggroup/malty.icons.power';
import { RadiobuttonOff } from '@carlsberggroup/malty.icons.radiobutton-off';
import { RadiobuttonOn } from '@carlsberggroup/malty.icons.radiobutton-on';
import { Refresh } from '@carlsberggroup/malty.icons.refresh';
import { Restaurant } from '@carlsberggroup/malty.icons.restaurant';
import { Retry } from '@carlsberggroup/malty.icons.retry';
import { Salesrep } from '@carlsberggroup/malty.icons.salesrep';
import { Save } from '@carlsberggroup/malty.icons.save';
import { Search } from '@carlsberggroup/malty.icons.search';
import { SearchUser } from '@carlsberggroup/malty.icons.search-user';
import { Sent } from '@carlsberggroup/malty.icons.sent';
import { Settings } from '@carlsberggroup/malty.icons.settings';
import { Share } from '@carlsberggroup/malty.icons.share';
import { ShieldExclamation } from '@carlsberggroup/malty.icons.shield-exclamation';
import { ShieldSecurity } from '@carlsberggroup/malty.icons.shield-security';
import { Shop } from '@carlsberggroup/malty.icons.shop';
import { SignOut } from '@carlsberggroup/malty.icons.sign-out';
import { Sort } from '@carlsberggroup/malty.icons.sort';
import { SpeachBalloon } from '@carlsberggroup/malty.icons.speach-balloon';
import { SpeachBalloonComplaint } from '@carlsberggroup/malty.icons.speach-balloon-complaint';
import { SpeachBalloonLivechat } from '@carlsberggroup/malty.icons.speach-balloon-livechat';
import { Star } from '@carlsberggroup/malty.icons.star';
import { StarFilled } from '@carlsberggroup/malty.icons.star-filled';
import { Survey } from '@carlsberggroup/malty.icons.survey';
import { SurveyCheck } from '@carlsberggroup/malty.icons.survey-check';
import { SurveyCheckbox } from '@carlsberggroup/malty.icons.survey-checkbox';
import { SurveyDefault } from '@carlsberggroup/malty.icons.survey-default';
import { SurveyTrophy } from '@carlsberggroup/malty.icons.survey-trophy';
import { Sync } from '@carlsberggroup/malty.icons.sync';
import { Tap } from '@carlsberggroup/malty.icons.tap';
import { TapGlass } from '@carlsberggroup/malty.icons.tap-glass';
import { TechnicalSupport } from '@carlsberggroup/malty.icons.technical-support';
import { Text } from '@carlsberggroup/malty.icons.text';
import { ThirdParty } from '@carlsberggroup/malty.icons.third-party';
import { ThumbDown } from '@carlsberggroup/malty.icons.thumb-down';
import { ThumbUp } from '@carlsberggroup/malty.icons.thumb-up';
import { ToggleOff } from '@carlsberggroup/malty.icons.toggle-off';
import { ToggleOn } from '@carlsberggroup/malty.icons.toggle-on';
import { Trash } from '@carlsberggroup/malty.icons.trash';
import { Trophy } from '@carlsberggroup/malty.icons.trophy';
import { Truck } from '@carlsberggroup/malty.icons.truck';
import { Tulipe } from '@carlsberggroup/malty.icons.tulipe';
import { Twitter } from '@carlsberggroup/malty.icons.twitter';
import { Underline } from '@carlsberggroup/malty.icons.underline';
import { Upload } from '@carlsberggroup/malty.icons.upload';
import { ViewGrid } from '@carlsberggroup/malty.icons.view-grid';
import { ViewList } from '@carlsberggroup/malty.icons.view-list';
import { Volume } from '@carlsberggroup/malty.icons.volume';
import { Wheat } from '@carlsberggroup/malty.icons.wheat';
import { World } from '@carlsberggroup/malty.icons.world';
import type { FC } from 'react';

export type IconComponents = {
  [icon: string]: FC<BaseIconProps>;
};

export const allMaltyIcons: IconComponents = {
  AddContent,
  AddEvent,
  AddProject,
  AddedDocument,
  Alert,
  AlertConnection,
  AppDropbox,
  AppFacebook,
  AppGithub,
  AppInstagram,
  AppLinkedin,
  AppPowerbi,
  AppSkype,
  Arrange,
  ArrowSmallDown,
  ArrowSmallLeft,
  ArrowSmallRight,
  ArrowSmallUp,
  At,
  Attachment,
  Balance,
  Bell,
  BellNotification,
  Bold,
  Book,
  Bookmark,
  BookmarkFilled,
  Bottle,
  BottleCraft,
  Calendar,
  CalendarAutumn,
  CalendarConfirm,
  CalendarEvents,
  CalendarSpring,
  CalendarSummer,
  CalendarWholeYear,
  CalendarWinter,
  Camera,
  Can,
  Card,
  CardPlus,
  CarlsbergFilled,
  CarlsbergOutlined,
  CarretDown,
  CarretLeft,
  CarretMove,
  CarretRight,
  CarretUp,
  Cart,
  CartAdded,
  CartLabel,
  CartNotification,
  Change,
  Check,
  CheckboxCheck,
  CheckboxCheckAlternate,
  CheckboxCheckOutline,
  CheckboxCheckSquare,
  CheckboxEmpty,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  ClockFilled,
  Clone,
  Close,
  CoinDollar,
  CoinEuro,
  Compass,
  CompassFilled,
  Connected,
  Contract,
  Cookies,
  Coupon,
  Customer,
  CustomerAdd,
  CustomerQuestion,
  Customers,
  DataTransfer,
  DiagonalDownLeft,
  DiagonalDownRight,
  DiagonalUpLeft,
  DiagonalUpRight,
  Diploma,
  Diploma2,
  Download,
  Draughtmaster,
  Edit,
  EllipsisVertical,
  Email,
  Expand,
  ExternalLink,
  EyeHide,
  EyeShow,
  File,
  FilesCsv,
  FilesJson,
  FilesPdf,
  FilesXls,
  Filters,
  Flash,
  GlassGoblet,
  GlassMug,
  GlassMugEmpty,
  GlassWeissbier,
  Globe,
  Headline,
  Heart,
  HeartFilled,
  Help,
  HideMenu,
  History,
  Home,
  Hop,
  Image,
  Information,
  Italic,
  ItemAdd,
  ItemBlock,
  ItemCheck,
  ItemCheckDefault,
  ItemCheckFilled,
  ItemClose,
  ItemCloseFilled,
  Library,
  Loading,
  LocationIp,
  Lock,
  LockOpen,
  Map,
  Market,
  MediaPause,
  MediaPlay,
  MediaSound,
  MediaSoundOff,
  MediaStop,
  Menu,
  MenuLeft,
  MenuRight,
  Minus,
  Mobile,
  More,
  Mouse,
  Notepad,
  Outlet,
  OutletPlus,
  Pack,
  PackageKeg,
  PackageWholesaler,
  Paint,
  Pallet,
  Pencil,
  PhoneClassic,
  Pilsner,
  Pin,
  PinActive,
  PinChurn,
  PinClosed,
  PinInactive,
  PinIndirect,
  PinLabeling,
  PinParked,
  PinProspect,
  PinSeveral,
  Pint,
  Plus,
  Power,
  RadiobuttonOff,
  RadiobuttonOn,
  Refresh,
  Restaurant,
  Retry,
  Salesrep,
  Save,
  Search,
  SearchUser,
  Sent,
  Settings,
  Share,
  ShieldExclamation,
  ShieldSecurity,
  Shop,
  SignOut,
  Sort,
  SpeachBalloon,
  SpeachBalloonComplaint,
  SpeachBalloonLivechat,
  Star,
  StarFilled,
  Survey,
  SurveyCheck,
  SurveyCheckbox,
  SurveyDefault,
  SurveyTrophy,
  Sync,
  Tap,
  TapGlass,
  TechnicalSupport,
  Text,
  ThirdParty,
  ThumbDown,
  ThumbUp,
  ToggleOff,
  ToggleOn,
  Trash,
  Trophy,
  Truck,
  Tulipe,
  Twitter,
  Underline,
  Upload,
  ViewGrid,
  ViewList,
  Volume,
  Wheat,
  World
};
